import { environment } from 'src/environments/environment';
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Package } from './models/package';
import { EPackageType } from './enum/e-package-type';

@Injectable({
providedIn: 'root'
})
export class PackageApiService {
  
  private baseUrl: string = environment.apiUrl;

  constructor(private http: HttpClient) {
  }

  getApiUrlCall(endUrl) {
    return this.baseUrl + endUrl;
  }

  getPackages(discriminator : EPackageType): Observable<Package[]> {
    const url = this.getApiUrlCall('api/Packages/GetPackages/' + discriminator);
    return this.http.get<Package[]>(url);
  }

  getPackage(packageId : number): Observable<Package> {
    const url = this.getApiUrlCall('api/Package/' + packageId);
    return this.http.get<Package>(url);
  }
  
  createPackage(pack: Package): Observable<Package> {
    const url = this.getApiUrlCall('api/Packages');
    return this.http.post<Package>(url, pack);
  }

  deletePackage(pack: Package): Observable<number> {
    const url = this.getApiUrlCall("api/Packages/" + pack.id);
    return this.http.delete<number>(url);
  }

  editPackage(pack: Package): Observable<any> {
    const url = this.getApiUrlCall("api/Packages/" + pack.id);
    return this.http.put(url, pack);
  }

}

